import { EnvironmentConfiguration } from "./EnvironmentConfiguration";

class ConfigService {

  private _configuration: EnvironmentConfiguration | undefined;

  public async getConfiguration(): Promise<EnvironmentConfiguration> {

    if (this._configuration) return this._configuration;

    const response = await fetch(process.env.PUBLIC_URL + "/config.json")
    const configuration = await response.json();
    
    this._configuration = configuration;

    return configuration;
  }
}

export const configService = new ConfigService();